export interface IState {
  xeroConnect: boolean;
  xeroTenantName: any;
  xeroEmailAddress: any;
  xeroLastSyncDate: any;
}

type Action = any;

export const xeroReducer = (
  state: IState = {
    xeroConnect: false,
    xeroTenantName: null,
    xeroEmailAddress: null,
    xeroLastSyncDate: null,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_XERO_CONNECT_LIST":
      return {
        ...state,
        xeroConnect: action.payload?.xero_connect,
        xeroTenantName: action.payload?.xero_tenant_name,
        xeroEmailAddress: action.payload?.xero_email_address,
      };
    case "GET_ONLY_STATUS_XERO":
      return {
        ...state,
        xeroConnect: action.payload?.xero_connect,
      };

    case "DISCONNECT_XERO":
      return {
        ...state,
        xeroTenantName: null,
        xeroEmailAddress: null,
      };

    case "GET_LAST_SYNC_DATE_XERO":
      return {
        ...state,
        xeroLastSyncDate: action?.payload,
      };
    case "WHEN_CONNECT_QUICKBOOKS_XERO_CLEAR":
      return {
        ...state,
        xeroConnect: false,
        xeroTenantName: null,
        xeroEmailAddress: null,
        xeroLastSyncDate: null,
      };
    default:
      return state;
  }
};
